
import Reports from '@/views/reports/Reports.vue'

export default [
  {
    path: 'reportes',
    name: 'reports',
    component: Reports
  }
]
